/**
 * Desc: 前五客户或者供应商资料.
 */
import React from 'react';
import NormalReportTip from '../../../common/normalReportTip/NormalReportTip';
import { Table } from 'antd';

export default function FirstFivePerson({ data, column, morFouty, title, subTitle }) {
    return (
        <div>
            <div className="sub-title">{title}</div>
            <div className="margin-bottom-10">
                {
                    morFouty && morFouty.map(item => (
                        <NormalReportTip key={item.name} name={item.name} customer={item.value} title={subTitle} />
                    ))
                }
            </div>
            <Table
                pagination={false}
                bordered
                rowKey="key"
                dataSource={data}
                columns={column}
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/financial/FirstFivePerson.jsx